export default __webpack_public_path__ + "static/media/Asset 1.eea697f5.svg";